import classNames from 'classnames'
import React, { useState } from 'react'

import Button from '~/components/button'
import { Input } from '~/components/checkbox-input/checkbox-input.styles'
import Modal from '~/components/modal'
import { i18n } from '~/i18n'

import {
  Label,
  SubLabel,
  Container,
  InputWrapper,
} from './sms-opt-in-input.styles'
import ContentBlock from '../content-block'

import type { ReactNode } from 'react'

type Props = {
  checked?: boolean
  onChange: (arg0: boolean) => void
  label?: ReactNode
  hasError?: boolean
  className?: string
  id?: string
  disabled?: boolean
  readOnly?: boolean
}

export default function SMSOptInInput({
  checked,
  onChange,
  label,
  className,
  id,
  disabled,
  readOnly,
}: Props) {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <Container htmlFor={id}>
      {label && <Label $disabled={disabled}>{label}</Label>}
      <InputWrapper>
        {!readOnly && (
          <Input
            className={classNames('input', className)}
            type="checkbox"
            disabled={disabled}
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            id={id}
          />
        )}
        <SubLabel $disabled={disabled}>
          {readOnly
            ? i18n.t('components.sms_opt_in_input.opted_in')
            : i18n.t('components.sms_opt_in_input.opt_in')}{' '}
          <Button
            type="inline"
            disabled={disabled}
            onClick={() => setModalOpen(true)}
          >
            {i18n.t('components.sms_opt_in_input.terms_of_service_btn')}
          </Button>
          {modalOpen && (
            <Modal
              size="small"
              title={i18n.t(
                'components.sms_opt_in_input.terms_of_service_title',
              )}
              onClose={() => setModalOpen(false)}
              actions={{
                primary: {
                  onClick: () => setModalOpen(false),
                  text: i18n.t('components.sms_opt_in_input.close_btn'),
                },
              }}
            >
              <ContentBlock>
                {i18n.t('components.sms_opt_in_input.terms_of_service_content')}
              </ContentBlock>
            </Modal>
          )}
        </SubLabel>
      </InputWrapper>
    </Container>
  )
}
